import React, { useState } from "react";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import "./App.css";

const App = () => {
  const [auth, setAuth] = useState(() => ({
    username: localStorage.getItem("username") || "",
    password: localStorage.getItem("password") || "",
    isLoggedIn: !!localStorage.getItem("username"),
  }));

  const handleLogin = (username, password) => {
    setAuth({ username, password, isLoggedIn: true });
    localStorage.setItem("username", username);
    localStorage.setItem("password", password);
  };

  const handleLogout = () => {
    setAuth({ username: "", password: "", isLoggedIn: false });
    localStorage.clear();
  };

  return auth.isLoggedIn ? (
    <Dashboard auth={auth} onLogout={handleLogout} />
  ) : (
    <Login onLogin={handleLogin} />
  );
};

export default App;
